import Swiper from 'swiper';
import {add_swiper_class} from '@canigo/js/tools/swiper';

export default class Slider {

    constructor() {
        Slider.hero();
        Slider.slider_related_post();
        Slider.slider_home();
        Slider.slider_gutenberg_block();
    }

    static add_swiper_class(container, wrapper, item) {
        $(container).addClass('swiper-container');
        $(wrapper).addClass('swiper-wrapper');
        $(item).addClass('swiper-slide');
    }

    static hero() {

        const slider = '[data-id="wpiris-hero-slider"]',
            slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
            slider_item = '[data-id="wpiris-hero-slider-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            const hero_slider = new Swiper($(slider), {
                init: false,
                // autoplay: true,
                speed: 1000,
                slidesPerView: 1,
                loop: true,
                lazy: true,
                navigation: {
                    prevEl: '.bannerMediaItemPrev',
                    nextEl: '.bannerMediaItemNext'
                }
            });

            // Set image navigation on slide change
            hero_slider.on('init slideChangeTransitionStart', function () {
                const swiper = this;
                const total_slides = $(swiper.el).find('.swiper-slide:not(.swiper-slide-duplicate)').length;

                // Prev
                if (swiper.navigation.prevEl) {

                    let prev_index = swiper.realIndex - 1;

                    if (prev_index < 0) {
                        prev_index = total_slides - 1;
                    }

                    const prev_image_nav = $(swiper.el).find('[data-swiper-slide-index="' + prev_index + '"]').data('image-nav');

                    $(swiper.navigation.prevEl).find('img').attr('src', prev_image_nav);
                }

                // Next
                if (swiper.navigation.nextEl) {

                    let next_index = swiper.realIndex + 1;

                    if (next_index > total_slides - 1) {
                        next_index = 0;
                    }

                    const next_image_nav = $(swiper.el).find('[data-swiper-slide-index="' + next_index + '"]').data('image-nav');

                    $(swiper.navigation.nextEl).find('img').attr('src', next_image_nav);
                }
            });

            hero_slider.init();
        }

    }

    static slider_related_post() {
        const slider = '[data-id="wpiris-relatedpost"]',
            slider_wrapper = '[data-id="wpiris-relatedpost-wrapper"]',
            slider_item = '[data-id="wpiris-relatedpost-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                speed: 600,
                slidesPerView: 1,
                pagination: {
                    el: '.swiperDots',
                    clickable: true,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1450: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                }
            });
        }
    }

    static slider_home() {
        let slider = '[data-id="wpiris-sliderhome"]',
            slider_wrapper = '[data-id="wpiris-sliderhome-wrapper"]',
            slider_item = '[data-id="wpiris-sliderhome-item"]';

        if ($(slider).length > 0) {

            $(slider).each(function () {

                let slider_elements = $(this).find(slider_item);

                if ($(slider_elements).length > 1) {

                    Slider.add_swiper_class($(this), $(this).find(slider_wrapper), $(this).find(slider_item));

                    let swiper_home = new Swiper($(this), {
                        mousewheel: {
                            forceToAxis: true,
                        },
                        keyboard: true,
                        spaceBetween: 0,
                        freeMode: true,
                        speed: 600,
                        slidesPerView: 1,
                        pagination: {
                            el: '.swiperDots',
                            clickable: true,
                        },
                    });
                }
            });
        }
    }

    static slider_gutenberg_block() {
        const slider = '[data-id="wpiris-block-slider"]',
            slider_wrapper = '[data-id="wpiris-block-slider-wrapper"]',
            slider_item = '[data-id="wpiris-block-slider-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                speed: 600,
                slidesPerView: 1,
                pagination: {
                    el: '.swiperDots',
                    clickable: true,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1450: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    }
                }
            });
        }
    }
}